/* eslint-disable */
import {
  Box,
  TextField,
  Typography,
} from '@mui/material'

import { numberInputStyle } from '../../constants/styleConstants'
import CardTAG from '../CardTAG'
import React from 'react'
import FormLayout from '../forms/FormLayout'
import { useDispatch, useSelector } from 'react-redux'
import reportsSelectors from '../../store/reports/reportsSelectors'
import { AppDispatch } from '../../store'
import {
  updateAnswerText,
  findItemByUuid
  
} from '../../store/reports/reportsSlice'
import { IQuestionComponent } from './types'
import authSelectors from '../../store/auth/authSelectors'



const NumberQuestionComponent: React.FC<IQuestionComponent> = ({
  questionObj,
  question,
  questionUUID,
  questionId,
  questionOptions,
  control,
  fieldName,
  unregister,
  setValue,
  setAnswersFiles,
  answers = [],
  answer: _answer,
  parent,
  previewOnly = false,
}) => {

  const userEditAccess = useSelector(authSelectors.userReportEditAccess)
  
  const dispatch = useDispatch<AppDispatch>()
  const getAnswer = () => {
    if (answers && answers?.length > 0) {
      return findItemByUuid(answers, questionUUID)
    }
    return useSelector(reportsSelectors.answersToCaseTypeQuestion(questionUUID))
  }
  const answer = _answer ? _answer : getAnswer()

  


  const onChangeHandler = (event: { target: { value: string } }) => {
    dispatch(
      updateAnswerText({
        answerUUID: answer?.uuid,
        answerText: event?.target?.value,
        parentUUID: parent?.uuid
      }),
    )
  }


  return (
    <div id={`${questionId}`}>
      <CardTAG
        questionCard={true}
        color={`${previewOnly ? 'tagBoxArchive' : 'tagBoxSuccess'}`}
        title={
          <Box sx={{ wordWrap: 'break-word', whiteSpace: 'unset', textOverflow: 'unset' }}>
            <Typography
              variant='h4'
              sx={{
                wordWrap: 'break-word',
                overflow: 'hidden',
              }}
            >
              {question}
            </Typography>
          </Box>
        }
        
      >
            <FormLayout>
              <TextField
                onChange={onChangeHandler}
                value={answer?.answer?.text}
                style={numberInputStyle}
                type='number'
                size='small'
                disabled={!userEditAccess || previewOnly}
                InputProps={{
                  inputProps: { min: 0, max: 100 },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormLayout>
        
        </CardTAG>
      </div>
  )
  
}

export default NumberQuestionComponent
